import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { routes } from "Projects/config/routes";
import ProjectDetails from "Projects/routes/ProjectDetails";
const {
  experiences: { path },
} = routes;
export default store => {
  return {
    path,
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "project-group" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [ProjectDetails(store)],
  };
};
